import { render } from "./ClosingFileTestResult.vue?vue&type=template&id=d1d34430"
import script from "./ClosingFileTestResult.vue?vue&type=script&lang=js"
export * from "./ClosingFileTestResult.vue?vue&type=script&lang=js"

import "./ClosingFileTestResult.vue?vue&type=style&index=0&id=d1d34430&lang=scss"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__